import http from '../../../utils/tools/http';

import {
  PAY_FETCH_ALI_SCAN_PAY_BEGIN,
  PAY_FETCH_ALI_SCAN_PAY_SUCCESS,
  PAY_FETCH_ALI_SCAN_PAY_FAILURE,
  PAY_FETCH_ALI_SCAN_PAY_DISMISS_ERROR,
} from './constants';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function fetchAliScanPay(args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: PAY_FETCH_ALI_SCAN_PAY_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      http.postAjax({
        url: '/datastore/PayGateway/AliScanPay',
        data: args,
        success: function (data) {
          if (data.SuccessResponse) {
            dispatch({
              type: PAY_FETCH_ALI_SCAN_PAY_SUCCESS,
              data,
            });
            resolve(data);
          }
        },
        error: function (error) {
          dispatch({
            type: PAY_FETCH_ALI_SCAN_PAY_FAILURE,
            data: { error: error },
          });
          reject(error);
        }
      })
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissFetchAliScanPayError() {
  return {
    type: PAY_FETCH_ALI_SCAN_PAY_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PAY_FETCH_ALI_SCAN_PAY_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        fetchAliScanPayPending: true,
        fetchAliScanPayError: null,
      };

    case PAY_FETCH_ALI_SCAN_PAY_SUCCESS:
      // The request is success
      return {
        ...state,
        fetchAliScanPayPending: false,
        fetchAliScanPaySuccess: action.data.Data,
      };

    case PAY_FETCH_ALI_SCAN_PAY_FAILURE:
      // The request is failed
      return {
        ...state,
        fetchAliScanPayPending: false,
        fetchAliScanPayError: action.data.error,
      };

    case PAY_FETCH_ALI_SCAN_PAY_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        fetchAliScanPayError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/pay/redux/fetchAliScanPay.js